import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../../../contexts/authContext';
import constants from '../../../constants';

export default function RoleRoute({ children, roles }) {
  const auth = useAuth();
  const location = useLocation();

  if (!roles.includes(auth.user.roleId)) {
    return <Navigate to={constants.routes.NOTFOUND.path} state={{ from: location }} replace />;
  }

  return children;
}

RoleRoute.propTypes = {
  children: PropTypes.element.isRequired,
  roles: PropTypes.array.isRequired
};